"use client";
import Link from "next/link";

export default function ApplyNowButtons() {
  const buttons = [
    {
      label: "Apply Now For Campus Programmes",
      url: "https://application.msu.edu.in/campus-programme-registration",
    },
    {
      label: "Apply Now For WISE Programmes",
      url: "https://apply.msu.edu.in/medhavi-wise",
    },
    {
      label: "Apply Now For Ph.D. Programmes",
      url: "https://application.msu.edu.in/msu-ph-d-application-form",
    },
    {
      label: "Apply Now For CRUX Programmes",
      url: "https://apply.msu.edu.in/msu-crux",
    },
    {
      label: "Apply Now For Industry Co-Led Programmes",
      url: "https://application.msu.edu.in/msu-industry-co-led-application-form",
    },
    {
      label: "Apply Now For International Programmes",
      url: "https://apply.msu.edu.in/medhavi-skills-university-international-application-form",
    },
  ];

  return (
    <section className="w-full py-6 bg-[#004760] sm:py-12 md:py-16">
      <div className="max-w-(--max-page-width) px-(--container-padding) mx-auto ">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 justify-items-center">
          {buttons.map((item, index) => (
            <Link
              key={index}
              href={item.url}
              className="flex items-center justify-center bg-[#FFA201] hover:bg-[#0b86bd]
               transition text-white font-medium text-sm md:text-base px-10 py-3 shadow-sm w-full
                text-center leading-snug min-h-17"
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
